import moment from 'moment-timezone';
import { useMemo } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import { AnchorButton } from '@payaca/ambrosia';
import QuickActionsElement from '@payaca/components/quickActionsTableCell/QuickActionsElement';

import {
  PublicServicePlanPrice,
  PublicServicePlanSubscription,
} from '@payaca/types/service-plans';

import {
  DateFormats,
  getInternationalMomentDateFormatByRegion,
} from '@payaca/helpers/internationalHelper';

import StatusBadge from '@payaca/components/statusBadge/StatusBadge';
import { useRegion } from '@/api/rest/users/useRegion';

type Props = {
  subscribers: PublicServicePlanSubscription[];
  servicePlanPrices: PublicServicePlanPrice[];
};
const ServicePlanSubscribersList = ({
  servicePlanPrices,
  subscribers,
}: Props) => {
  const history = useHistory();
  const region = useRegion();

  const subscribersWithBilling = useMemo(() => {
    return subscribers.map((sub) => {
      const servicePlanPrice = servicePlanPrices.find(
        (spp) => spp.publicId === sub.servicePlanPricePublicId
      );
      let displayBillingInterval = '';
      if (servicePlanPrice?.billingInterval === 'year') {
        displayBillingInterval = 'Annual';
      } else if (servicePlanPrice?.billingInterval === 'month') {
        displayBillingInterval = 'Month';
      }
      return {
        ...sub,
        billingInterval: displayBillingInterval,
      };
    });
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useMemo has a missing dependency: 'servicePlanPrices'
  }, [subscribers]);

  const timestampRegionalFormat = useMemo(
    () => getInternationalMomentDateFormatByRegion(DateFormats.MID, region),
    [region]
  );

  return (
    <div className="service-plan-subscribers-list">
      {subscribersWithBilling.map((subscriber, i) => (
        <div
          key={`service-plan-customer-${i}`}
          className="service-plan-customer"
        >
          <div className="service-plan-customer-body">
            <div>
              <AnchorButton
                as={Link}
                to={`/customers/${subscriber.customerId}?servicePlanId=${subscriber.servicePlanPublicId}`}
                variant="link"
              >
                {subscriber.customerName}
              </AnchorButton>
            </div>
            <span>
              {subscriber.status === 'active' ? (
                <>
                  Joined{' '}
                  {moment(subscriber.validFrom).format(timestampRegionalFormat)}
                </>
              ) : (
                <>Payment pending</>
              )}
            </span>
            <StatusBadge>{subscriber.billingInterval}</StatusBadge>
          </div>
          <QuickActionsElement
            recordId={subscriber.customerId}
            quickActions={[
              {
                actionName: 'View service periods',
                actionBehaviour: () => {
                  history.push(
                    `/service-plans/service-periods?customerId=${subscriber.customerId}`
                  );
                },
              },
            ]}
          />
        </div>
      ))}
    </div>
  );
};

export default ServicePlanSubscribersList;
